// extracted by mini-css-extract-plugin
module.exports = {"dpu-new2":"NEW2_dpu-new2__13OVP"};